// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5271) return "5271.a0339980ac797341d07b.js";
	// return url for filenames based on template
	return "" + {"1167":"49bbba69bb1e08d11274","6449":"6dbe9af37cef991b1367"}[chunkId] + ".js";
};